export default "__VITE_ASSET__bc72dea6__"